

export const BNBlist = [
     {
      "chainId": 56,
      "address": "0x55d398326f99059fF775485246999027B3197955",
      "name": "USDT",
      "symbol": "USDT",
      "decimals": 18,
      "logoURI": require('@/assets/tokenlogo/USDT.png')
    },

    {
      "chainId": 56,
      "address": "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
      "name": "BTCB",
      "symbol": "BTCB",
      "decimals": 18,
      "logoURI": require('@/assets/tokenlogo/BTCB.png')
    },
    {
      "chainId": 56,
      "address": "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
      "name": "ETH",
      "symbol": "ETH",
      "decimals": 18,
      "logoURI": require('@/assets/tokenlogo/ETH.png')
    },
     {
    "chainId": 56,
    "address": "0xEaAE2cbe4C153f7F012f7326D1106013a2b76422",
    "name": "DF",
    "symbol": "DF",
    "decimals": 18,
    "logoURI": require('@/assets/tokenlogo/DF.png')
  },
  {
    "chainId": 56,
    "address": "0x7eDE261faf197771E4bB9b7277E8086Fb52e72A4",
    "name": "CPT",
    "symbol": "CPT",
    "decimals": 18,
    "logoURI": require('@/assets/tokenlogo/CPT.png')
  },
]


